import {
  GET_CHANGE_REQUESTS_REQUEST,
  GET_CHANGE_REQUESTS_SUCCESS,
  GET_CHANGE_REQUESTS_FAILURE,
  CREATE_CHANGE_REQUEST_REQUEST,
  CREATE_CHANGE_REQUEST_SUCCESS,
  CREATE_CHANGE_REQUEST_FAILURE,
  statusType
} from '../../actions'

const initial = {
  data: [],
  total: 0,
  meta: {
    total: 0,
    maxTotal: 0
  },
  status: statusType.IDLE,
  initialLoading: true
}

const changeRequest = (state = initial, action) => {
  const { payload, meta } = action

  switch (action.type) {
    case GET_CHANGE_REQUESTS_REQUEST:
    case CREATE_CHANGE_REQUEST_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case GET_CHANGE_REQUESTS_SUCCESS:
      return {
        ...state,
        ...meta,
        data: payload,
        status: statusType.SUCCESS,
        initialLoading: false
      }

    case GET_CHANGE_REQUESTS_FAILURE:
    case CREATE_CHANGE_REQUEST_FAILURE:
      return {
        ...state,
        status: statusType.ERROR,
        initialLoading: false
      }

    case CREATE_CHANGE_REQUEST_SUCCESS:
      return {
        ...state,
        status: statusType.SUCCESS,
        initialLoading: false
      }

    default:
      return state
  }
}

export default changeRequest